import { getOutOfStockProductsText } from '../Helpers/GeneralHelper.js';
import { AdobeAnalyticsUtil } from '/Foundation/Common/code/Views/Foundation/Common/AdobeAnalytics/AdobeAnalyticsUtil';
import { setAdobeDataLayerProductsFromOrder } from '/Foundation/Common/code/Helpers/TrackingHelper.js';

export const trackPageview = (checkoutStep, isFirstStep, cart, translations) => {
  if (!window.adobeDataLayer) return;

  if (isFirstStep && cart?.lineItems?.filter((x) => !x.isInStock)?.length > 0) {
    let oosErrorMessage = getOutOfStockProductsText(cart, translations);
    window.adobeDataLayer.page.error_message = oosErrorMessage;
  }

  window.adobeDataLayer.checkout = { step: checkoutStep };
  window.adobeDataLayer.page.title = capitalize(checkoutStep);

  AdobeAnalyticsUtil.DataLayer.TrackEvent('pageview');
};

export const trackConfirmation = async (order) => {
  if (!window.adobeDataLayer || Object.keys(order).length === 0) return;

  await setAdobeDataLayerProductsFromOrder(order);

  if (!window.adobeDataLayer.checkout) window.adobeDataLayer.checkout = {};

  window.adobeDataLayer.checkout.step = 'order confirmation';
  window.adobeDataLayer.checkout.shipping_method =
    order?.deliveries?.map((delivery) => delivery.shippingMethodName).join(', ') ?? '';
  window.adobeDataLayer.checkout.payment_provider = order?.paymentMethodName;
  window.adobeDataLayer.checkout.shipping_cost = order?.shippingTotal >= 0 ? order.shippingTotal.toString() : '';
  window.adobeDataLayer.checkout.vat = order?.taxTotal >= 0 ? order?.taxTotal.toString() : '';

  window.adobeDataLayer.page.title = 'Order confirmation';

  window.adobeDataLayer.purchase_id = order?.orderNumber;

  AdobeAnalyticsUtil.DataLayer.TrackEvent('pageview');
};

function cloneAdobeDataLayerSnapshot() {
  try {
    if (typeof structuredClone === 'function') {
      return structuredClone(window.adobeDataLayer);
    }
  } catch {
    // non-cloneable values fall through
  }
  return JSON.parse(JSON.stringify(window.adobeDataLayer));
}

export const trackCheckoutClick = () => (_, getState) => {
  if (!window.adobeDataLayer) return;

  const state = getState();
  const dataLayer = cloneAdobeDataLayerSnapshot();

  let selectedShippingMethodName = '';

  if (state.Shipping.nshiftEnabled) {
    selectedShippingMethodName = state.Shipping?.selectedExternalShippingMethod?.subShipments
      .map((sub) => {
        return sub.optionTitle;
      })
      .join(', ');
  } else {
    selectedShippingMethodName = state.Shipping?.shippingMethods?.find(
      (x) => x.id === state.Shipping?.selectedShippingMethod
    )?.name;
  }

  if (selectedShippingMethodName) {
    dataLayer.checkout.shipping_method = selectedShippingMethodName;
  }

  const selectedPaymentMethodName = state.Payment?.selectedPaymentMethod;

  if (selectedPaymentMethodName) {
    dataLayer.checkout.payment_provider = selectedPaymentMethodName;
  }

  AdobeAnalyticsUtil.DataLayer.TrackEvent('checkout_click', dataLayer);
};

const capitalize = (word) => {
  return word.charAt(0).toUpperCase() + word.slice(1);
};
